<!--
 * @Author: Gaho
 * @Date: 2024-06-27 18:04:33
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-23 13:45:24
 * @Description: 
-->
<template>
    <Modal
        v-bind="$attrs"
        :model-value="modelValue"
        v-if="modelValue"
        @click.self="() => onBackdrop()"
        class="w-full modal-header win-jackpot"
    >
        <!-- Header -->
        <div
            class="!z-20 py-[16px] px-[24px] text-2xl relative items-center text-white font-bold flex justify-between"
        >
            <div class="flex w-full flex-col items-center justify-center">
                <h2 class="text-[#2283f6] leading-[32px] text-[24px]">{{ $t('Congratulations') }}</h2>
                <h4 class="text-[18px] leading-[24px]">{{ $t('youWin') }}</h4>
            </div>

            <QIcon 
                name="close" 
                class="text-[#93acd3] cursor-pointer absolute top-[24px] right-[0px]" 
                @click="close" 
            />
        </div>

        <!-- Body -->
        <div class="relative">
            <img src="@/assets/imgs/jackpot/jackpot-label.webp" alt="">
            <img class="game-img mb-[16px]" :src="setWinJackpotImg()" alt="">
            <div class="flex items-center gap-[8px] mb-[34px] justify-center">
                <CurrentCoin size="32px" :name="data?.currency || 'btc'" />
                <span class="text-[#ffb636] text-[32px] font-bold">
                    {{ data?.win_jackpot_amount?.toFixed(2) }}
                </span>
            </div>
        </div>
        <div class="jackpot-coins">
            <img src="@/assets/imgs/jackpot/coins.webp" alt="">
        </div>
    </Modal>
</template>

<script lang="ts" setup>
// stores
import useGlobalStore from '@/stores/global';
// sockets
import { useJackPotSocket } from '~/socket/jackpot';
import plinkoImg from '@/assets/imgs/jackpot/plinko_small.webp';
import diceImg from '@/assets/imgs/jackpot/dice_small.webp';
import spaceDiceImg from '@/assets/imgs/jackpot/spacedice_small.webp';
import hiloImg from '@/assets/imgs/jackpot/hilo_small.webp';
import crashImg from '@/assets/imgs/jackpot/crash_small.webp';
import circleImg from '@/assets/imgs/jackpot/circle_small.webp';
// ↑ 图像
// ↓ 音效、其它等
import winJackpotSound from '@/assets/mp3/jackpot/win-jackpot.mp3'; 
import winJackpotSoundPlinko from '@/assets/mp3/jackpot/plinkoJacpot.mp3'; 
import {getGameName} from '@/common/js/gameAbout';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
    data: {
        type: Object,
        default: {},
    },
});
const globalStore = useGlobalStore();
const emit = defineEmits(['update:modelValue']);
const close = () => {
    emit('update:modelValue', false);
};

const oMusic = new MusicControler({
    winJackpot: {
        src: winJackpotSound,
    },
    winJackpotPlinko: {
        src: winJackpotSoundPlinko,
    },
} as any);


const onBackdrop = () => {
    if (props.backdrop) {
        close();
    }
};
/**
 * 设置不同游戏的winjackpot图片
 */
const setWinJackpotImg = () => {
    let src = '';
    switch(props.data?.game){
        case 'plinko':
            src = plinkoImg;
        break;
        case 'dice':
            src = diceImg;
            break;
        case 'spacedice':
            src = spaceDiceImg;
            break;
        case 'hilo':
            src = hiloImg;
            break;
        case 'circle':
            src = circleImg;
            break;
        case 'crash':
            src = crashImg;
            break;
        default:
    }
    return src;
}


watch(() => props.modelValue, (value) => {
    if (!value){
        document.body.style.overflow = 'auto';
        return;
    }
    // ↑ 窗口已经被关闭
    // ↓ 窗口打开了
    document.body.style.overflow = 'hidden';
    console.log("jackpot 窗口已经打开 ✨"); 
    // ↓ 在 toPlay() 内部会自动判断播放音效或不播
    if (getGameName().includes('plinkoGame')){
        oMusic.oAudio.winJackpotPlinko.toPlay();
    }else{
        oMusic.oAudio.winJackpot.toPlay();
    }
    const { EMIT_JACKPOT_GETSUM } = useJackPotSocket()
    // 中奖后更新jackpot数据
    EMIT_JACKPOT_GETSUM({}, (res) => {
        globalStore.jackpotSum = res;
    });
});

onBeforeUnmount(()=>{
    oMusic?.toDestory();
});

</script>

<style lang="scss" scoped>
.modal-header::before {
    background: linear-gradient(180deg, #003370, transparent);
    border-radius: 14px 14px 0 0;
    content: '';
    display: block;
    height: 72px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
}

.game-img {
    animation: scale 1.5s ease-in-out infinite;
    transform: scale(.95);
}
.jackpot-coins {
    height: 290px;
    left: -30px;
    pointer-events: none;
    position: absolute;
    right: -30px;
    top: 180px;
    user-select: none;
    img {
        animation: poof 1s ease-in-out .5s;
        animation-fill-mode: forwards;
        transform: scale(.01);
    }
}
@keyframes poof {
    0% {
        transform: scale(.1)
    }

    to {
        transform: scale(1.2)
    }
}
@keyframes scale {
    0% {
        transform: scale(.975)
    }

    50% {
        transform: scale(1.025)
    }

    to {
        transform: scale(.975)
    }
}
</style>

<style lang="scss">
.win-jackpot .dialog {
    max-width: min(92vw, 360px);
    border-radius: 12px;
    opacity: 1;
    position: relative;
    text-align: left;
    transform: translateZ(0);
    white-space: normal;
    width: 100%;
    background: radial-gradient(86.94% 55.18% at 50% 55.18%,#1f86ff 0,#062c5a 65.92%,#042041 82.29%,#001630 95.08%),linear-gradient(180deg,#003370,#03254e 25.17%,#051d39 46.77%,#111923 71.79%);
    overflow: visible!important;
    min-height: 62px;
    padding: 0px 24px;
    z-index: 2;
    margin: 0;
    &::after {
        animation: spin 24s linear infinite;
        background-image: url('@/assets/imgs/jackpot/lines-bg.webp');
        background-repeat: no-repeat;
        content: "";
        height: 460px;
        left: 0;
        position: absolute;
        top: 100px;
        width: 360px;
        z-index: -1;
    }
}
@keyframes spin {
    to {
        transform: rotate(1turn)
    }
}
</style>
